import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--editable-title"
export default class extends Controller {
  static targets = ["input", "label", "button", "formButtonArea"];
  static values = { defaultEditable: Boolean };

  connect() {
    if (this.defaultEditableValue) {
      this.edit();
      this.inputTarget.focus();
      requestAnimationFrame(() => {
        this._scrollToField(this.inputTarget);
      });
    }
  }

  edit(e) {
    e?.preventDefault();

    this.inputTarget.classList.remove("hidden");
    this._focusAndMoveCaretToEnd();

    this.labelTarget.classList.add("hidden");
    this.buttonTarget.classList.add("hidden");
    this.formButtonAreaTarget.classList.remove("hidden");
  }

  cancel(e) {
    e.preventDefault();

    this.inputTarget.classList.add("hidden");

    this.labelTarget.classList.remove("hidden");
    this.buttonTarget.classList.remove("hidden");
    this.formButtonAreaTarget.classList.add("hidden");
  }

  _focusAndMoveCaretToEnd() {
    this.inputTarget.focus();
    const length = this.inputTarget.value.length;
    this.inputTarget.setSelectionRange(length, length);
  }

  _scrollToField(element) {
    if (!element) return;

    const y = element.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  }
}
